import { render, staticRenderFns } from "./QrFamilyRedirect.vue?vue&type=template&id=f04cf1d4&"
import script from "./QrFamilyRedirect.vue?vue&type=script&lang=js&"
export * from "./QrFamilyRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports